"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ContentMetrics = void 0;
var ContentMetrics;
(function (ContentMetrics) {
    ContentMetrics["AttractivityRate"] = "attractivityRate";
    ContentMetrics["ClickRate"] = "clickRate";
    ContentMetrics["ConversionRate"] = "conversionRate";
    ContentMetrics["ProductConversionRate"] = "productConversionRate";
    ContentMetrics["Revenue"] = "revenue";
    ContentMetrics["TotalClicks"] = "totalClicks";
    ContentMetrics["Views"] = "views";
})(ContentMetrics = exports.ContentMetrics || (exports.ContentMetrics = {}));
//# sourceMappingURL=product.model.js.map